var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-dynaview view"},_vm._l((_vm.compData),function(item){return _c(item.code,{key:item.code,tag:"div",attrs:{"option":item.option,"comp_name":item.name,"comp_code":item.code}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }